const getData = (state, selector) => {
  const data = state.Pupils.setAgeGroupDialog
    ? state.Pupils.setAgeGroupDialog
    : state
  return !data ? null : selector(data)
}

const isOpen = state => getData(state, data => data.opened)
const getPupilsIds = state => getData(state, data => data.ids)

export { isOpen, getPupilsIds }
